module.exports = "/assets/data/8be842c7a116e812164a4c289a72a7dd-WV6.data.json";